function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TickIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M19.1992 5L20.6543 6.37305L7.62109 19.7647L3 14.9282L4.45508 13.5552L7.6211 16.8506L19.1992 5Z",
    fill: "currentColor"
  }));
}
export function TickIconSmall(props) {
  return ___EmotionJSX(TickIcon, _extends({
    size: "small"
  }, props));
}